import Humanize from 'humanize-plus'
import React from "react";
import { Spin } from "antd";

import "./styles.css"

export const Price = ({value, loading = false, ...props}) => {
    return (
        <div className={"render-price"} style={{
            display: "inline"
        }}>
            <Spin spinning={loading}>
             <span
                 style={{
                     fontSize: 12,
                 }} {...props}>{`$`}&nbsp;{`${Humanize.formatNumber(value, 2)}`}</span>

            </Spin>
        </div>
    );
}
